// orbital-lint wordmark components.
//
// The glyph (a tilted elliptical orbit with a planet dot at the lower-left)
// and the geometric "Outfit" typeface match the orbital-reg brand. The ring +
// dot and the "LINT" suffix all use the mint --orb-accent (via currentColor) so
// the glyph and the tool name read as one colour and stay theme-adaptive.
//
// Two exports:
//   WordmarkBase  — just the SVG glyph + "ORBITAL/" text. Used inside a <Link>
//                   in TopNav so the brand is the home-page anchor.
//   Wordmark      — full "ORBITAL/LINT" for contexts that need the whole thing
//                   (e.g. login/error pages). T296 moved "LINT" out of TopNav's
//                   Link into the standalone ToolSwitcher component.

export function WordmarkBase() {
  return (
    <span className="orb-wordmark inline-flex items-center gap-2">
      <svg
        width="24"
        height="24"
        viewBox="0 0 44 44"
        className="shrink-0"
        aria-hidden="true"
      >
        <ellipse
          cx="22"
          cy="22"
          rx="18"
          ry="7.5"
          fill="none"
          stroke="#5b8def"
          strokeWidth="2.4"
          transform="rotate(-28 22 22)"
        />
        <circle cx="8.5" cy="30" r="3.4" fill="#5b8def" />
      </svg>
      <span className="inline-flex items-baseline">
        <span className="text-fg">ORBITAL</span>
        <span className="mx-0.5 text-fg-subtle" aria-hidden="true">
          /
        </span>
      </span>
    </span>
  );
}

export function Wordmark() {
  return (
    <span className="orb-wordmark inline-flex items-center gap-2" aria-label="Orbital/Lint">
      <svg
        width="24"
        height="24"
        viewBox="0 0 44 44"
        className="shrink-0 text-accent"
        aria-hidden="true"
      >
        <ellipse
          cx="22"
          cy="22"
          rx="18"
          ry="7.5"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.4"
          transform="rotate(-28 22 22)"
        />
        <circle cx="8.5" cy="30" r="3.4" fill="currentColor" />
      </svg>
      <span className="inline-flex items-baseline">
        <span className="text-fg">ORBITAL</span>
        <span className="mx-0.5 text-fg-subtle" aria-hidden="true">
          /
        </span>
        <span data-tool-switch className="text-accent">
          LINT
        </span>
      </span>
    </span>
  );
}
